module.exports = __webpack_public_path__ + "img/bg02.c411697d.png";